export default __webpack_public_path__ + "static/media/macs-logo.db2d537d.png";